import { useCallback, useEffect, useState } from 'react';
import { BrowserRouter, Routes, Route, Outlet } from "react-router-dom";
import './App.scss';
import { useAction } from './store'
import { Content, Footer, Header, InfoMessage, LoginModal, NotFound } from './components';
import { Admin, Forum, History,Home, Registration, Rules, Stats, Teams } from './pages';
import { useAppState } from './store';
import { AUTH_COOKIE, getCookie } from './utils';
import { EPage } from '@sifrovacihra/shared-ui';
import "@sifrovacihra/shared-ui/dist/index.css"

function App() {
    const { setAppMenuAction, setTokenAction } = useAction()
    const { state } = useAppState()
    const [loginModalVisible, setLoginModalVisible] = useState(false)

    const handleLoginModalOpen = () => setLoginModalVisible(true);
    const handleLoginModalClose = () => setLoginModalVisible(false);


    useEffect(() => {
        console.log("App reloaded!")
        setAppMenuAction(false)
        if (!state?.token) {
            const cookie = getCookie(AUTH_COOKIE)
            if (cookie) {
                setTokenAction(cookie)
            }
        }
    }, [setAppMenuAction, setTokenAction, state?.token])

    const Layout = useCallback(() => {
        return (
            <>
                <Header handleLoginModalOpen={handleLoginModalOpen} />
                <LoginModal open={loginModalVisible} handleClose={handleLoginModalClose} />
                <InfoMessage />
                < Content >
                    <>
                        <Outlet />
                    </>
                </Content >
                <Footer />
            </>
        )
    }, [loginModalVisible])

    return (
        <div className="App">
            <BrowserRouter>
                <Routes>
                    <Route element={<Layout />}>
                        <Route index element={<Home />} />
                        <Route path={EPage.ADMIN} element={<Admin />} />
                        <Route path={EPage.FORUM} element={<Forum />} />
                        <Route path={EPage.HISTORY} element={<History />} />
                        <Route path={EPage.HOME} element={<Home />} />
                        <Route path={EPage.RULES} element={<Rules />} />
                        <Route path={EPage.REGISTRATION} element={<Registration />} />
                        <Route path={EPage.STATS} element={<Stats />} />
                        <Route path={EPage.TEAMS} element={<Teams />} />
                        <Route path="*" element={<NotFound />} />
                    </Route>
                </Routes>
            </BrowserRouter>
        </div>
    );
}

export default App;
